<template>
  <el-dialog
    top="50px"
    width="400px"
    :title="isCreate ? 'Thêm đối tượng mới' : 'Sửa đối tượng'"
    :visible="visible"
    :show-close="!callingAPI"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :show-message="true"
      :disabled="callingAPI"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="type"
label="Loại đối tượng">
            <el-select
              v-model="form.type"
              placeholder="Chọn loại"
              class="w-100"
              :disabled="!isCreate"
            >
              <el-option
                v-for="op in typeOptions"
                :key="op.value"
                :label="op.label"
                :value="op.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="key"
label="Mã đối tượng">
            <el-input
              v-model="form.key"
              :disabled="!isCreate"
              placeholder="Nhập thông tin"
              @input="form.key = form.key.toLowerCase()"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="name"
label="Tên đối tượng">
            <el-input
v-model="form.name"
placeholder="Nhập thông tin" />
          </el-form-item>
        </el-col>
        <el-col
v-if="isCreate"
:lg="24"
:span="24">
          <el-form-item
prop="clone_type"
label="Đối tượng sao chép">
            <el-select
              v-model="form.clone_type"
              placeholder="Chọn đối tượng"
              class="w-100"
            >
              <el-option
                v-for="op in cloneTypes"
                :key="op.id"
                :label="op.extra.name"
                :value="op.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
slot="footer"
class="dialog-footer">
      <el-button
:disabled="callingAPI"
size="medium"
@click="$emit('close')">
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import configServices from "@/services/config";
import { notification } from "@/utils/common";
import CONSTANTS from "@/config/constants.js";
import PATTERNS from "@/config/patterns.js";

export default {
  name: "ObjectFormPopup",
  props: {
    item: Object,
    visible: Boolean,
    allConfigs: Array,
    orgId: String
  },
  data() {
    return {
      form: {
        type: this.item ? this.item?.type : "",
        key: this.item ? this.item?.extra?.key : "",
        name: this.item ? this.item?.extra?.name : "",
        clone_type: null,
      },
      typeOptions: CONSTANTS.OBJECT_TYPES,
      callingAPI: false,
    };
  },
  computed: {
    allConfigKeys() {
      return this.allConfigs.map((c) => c.extra.key);
    },
    cloneTypes() {
      if (this.form.type === "categories") {
        return this.allConfigs.filter((c) => c.type === "categories");
      }
      return this.allConfigs.filter((c) => c.type !== "categories");
    },
    rules() {
      const validateKey = (rule, value, callback) => {
        if (value && CONSTANTS.BLOCK_TYPES.includes(value.trim())) {
          callback(new Error("Mã đối tượng trùng với mã hệ thống"));
        } else if (
          !this.item?.id &&
          value &&
          this.allConfigKeys.includes(
            value.trim()
          )
        ) {
          callback(
            new Error("Mã đối tượng đã tồn tại")
          );
        } else {
          callback();
        }
      };
      return {
        type: [
          {
            required: true,
            message: "Loại đối tượng không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        key: [
          {
            required: true,
            message: "Mã đối tượng không được để trống",
            trigger: ["blur", "change"],
          },
          {
            pattern: PATTERNS.KEY,
            message: "Mã đối tượng không hợp lệ",
            trigger: ["blur", "change"],
          },
          {
            validator: validateKey,
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "Tên đối tượng không được để trống",
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    isCreate() {
      return !this.item || !this.item.id;
    },
    payload() {
      const result = {
        type: this.form.type,
        extra: {
          key: this.form.key,
          name: this.form.name,
          organization_id: this.orgId
        },
      };
      if (!this.isCreate) {
        return {
          id: this.item.id,
          type: this.form.type,
          extra: {
            ...this.item.extra,
            ...result.extra,
          },
        };
      }
      const selectedConfig = this.allConfigs.find(
        (c) => c.id === this.form.clone_type
      );
      return {
        ...result,
        extra: selectedConfig
          ? {
              ...selectedConfig.extra,
              ...result.extra,
              is_publish: false,
              info: {
                menu: this.form.name,
                icon: "",
                order: 0,
              },
            }
          : {
              ...result.extra,
              is_publish: false,
              info: {
                menu: this.form.name,
                icon: "",
                order: 0,
              },
              header_actions: [],
              column_actions: [],
              groups: [],
              fields: [],
              relations: [],
              actions: [],
              import_templates: [],
              modules: [],
              contacts: []
            },
      };
    },
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          configServices[!this.isCreate ? "update" : "create"](
            this.payload
          )
            .then((response) => {
              this.callingAPI = false;
              this.$emit("reload", response);
              notification(
                this,
                "success",
                !this.isCreate ? "update" : "create",
                `${this.form.name}`
              );
              if (this.isCreate) {
                // this.$router.push({
                //   name: "ConfigDetail",
                //   params: { id: response?.items[0]?.id },
                // });
              }
              this.$emit("close");
            })
            .catch(() => {
              this.callingAPI = false;
              notification(
                this,
                "error",
                !this.isCreate ? "update" : "create",
                `${this.form.name}`
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
